exports.components = {
  "component---src-components-gatsby-templates-wiki-tsx": () => import("./../../../src/components/gatsby-templates/Wiki.tsx" /* webpackChunkName: "component---src-components-gatsby-templates-wiki-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-graph-tsx": () => import("./../../../src/pages/graph.tsx" /* webpackChunkName: "component---src-pages-graph-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

